import React, { useEffect, useState } from "react";
import CuerpoPrincipal from "../elementos/basicos/CuerpoPrincipal";
import ContenedorPrincipal from "../elementos/basicos/ContenedorPrincipal";
import FormCrearCategoria from "../elementos/complejos/FormCrearCategoria";
import FormEditarCategoria from "../elementos/complejos/FormEditarCategoria";
import { fechtOptenerModelos } from '../../peticiones_API/PeticionesCursoConvocatoria';
import Navbar from "../elementos/cuerpo/Navbar";
const GestorCategoria = ({ crear }) => {
  
  const [loading, setLoading] = useState(true);
  const [subcategorias, setSubcategorias] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        
          const listadoResponse = await fechtOptenerModelos(["SubCategoria"], true);
          console.log("listadoResponse", listadoResponse);
          setSubcategorias(listadoResponse.SubCategoria);
        
        setLoading(false);
      } catch (error) {
        console.log("Ha habido un error:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <>
        <ContenedorPrincipal formaform="true"  >

        { crear ?
          <FormCrearCategoria 
          subcategorias={subcategorias}
          />
          :
          <FormEditarCategoria
          subcategorias={subcategorias}
          />
        }
          

        </ContenedorPrincipal>
    </>
  );
}

export default GestorCategoria;